//IB WALLET BALANCE

import api from "../utils/axiosInstance.js";
import { GET_ASSETS_LIST, GET_ASSETS_LIST_ERROR, GET_ASSETS_LIST_REQUEST, UPDATE_ASSETS_LIST_DATA, REMOVE_ASSETS_LIST } from "../ActionTypes/ActionTypes.js";


const getAssetListRequest = () => ({ type: GET_ASSETS_LIST_REQUEST });
const getAssetListSuccess = (data) => ({ type: GET_ASSETS_LIST, payload: data });
const getAssetListError = (error) => ({ type: GET_ASSETS_LIST_ERROR, payload: error });

export const getAllAssetList = (data) => async (dispatch) => {
    dispatch(getAssetListRequest());
    try {


        const response = await api.post(`/user/assets/list`, data);

        if (response.data.success) {
            dispatch(getAssetListSuccess(response.data));

        }
        else {
            dispatch(getAssetListError(response?.data?.message));
        }



    } catch (error) {
        dispatch(getAssetListError(error.response?.data?.message || error.message));
    }
};

export const updateAssetListData = (newData) => ({
    type: UPDATE_ASSETS_LIST_DATA,
    payload: newData,
});


export const removeAssetListData = (newData) => ({
    type: REMOVE_ASSETS_LIST,
    payload: newData,
});

